export const CHAT_TYPE = {
  REGULAR: "regular",
  SCRIPT: "script",
  SOP: "sop",
};
